import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Typography, Toolbar, Button, IconButton, Grid } from '@mui/material';
import UserMenu from './UserMenu';
import LocaleMenu from './LocaleMenu';
import { useContext, useState } from 'react';
import { appUserContext } from 'helpers/services';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import Sidebar from './Sidebar';
import { MdMenu as MenuIcon } from 'react-icons/md';


let CustomerNavBar = () => {
    let { formatMessage } = useIntl();
    let { currentUser, isMobile } = useContext(appUserContext);

    let [showSidebar, setShowSidebar] = useState(false);

    return (
        <AppBar elevation={0} position="sticky">
            <Toolbar variant="dense" >
                <RouterLink to="/">
                    <img alt="Simec My" style={{ width: 40, textAlign: 'center' }} src="/images/logo_ipad.png" />
                </RouterLink>
                {process.env.REACT_APP_ENVIRONMENT === "staging" &&
                    <Typography component="span" style={{ color: '#354249' }}>
                        <strong>Staging env.</strong>
                    </Typography>
                }

                {isMobile === true &&
                    <Grid container p={0}>
                        <Grid item xs p={0} />
                        <Grid item p={0}>
                            <IconButton color="inherit" onClick={() => setShowSidebar(true)} size="large">
                                <MenuIcon />
                            </IconButton>
                        </Grid>
                        <Sidebar
                            sidebarOpen={showSidebar}
                            closeSidebar={() => setShowSidebar(false)}
                        />
                    </Grid>
                }

                {isMobile === false &&
                    <Grid container alignItems="center">
                        <Grid item xs p={0}>
                            <Button
                                component={RouterLink}
                                style={{ color: 'white' }}
                                to={'/customer/tickets'}
                            >
                                Tickets
                            </Button>
                            {currentUser?.customerClaims?.isAdmin === true &&
                                <Button
                                    component={RouterLink}
                                    style={{ color: 'white' }}
                                    to="/customer/users"
                                >
                                    {formatMessage({ id: LocalizationIds.Users })}
                                </Button>

                            }
                        </Grid>
                        <Grid item p={0}>
                            <LocaleMenu />
                        </Grid>
                        <Grid item p={0}>
                            <UserMenu />
                        </Grid>
                    </Grid>
                }
            </Toolbar>
        </AppBar>
    );
}

export default CustomerNavBar;